import React, { Component } from 'react';
import './RadioOption.css';

class RadioOption extends Component {

    constructor(props) {
        super(props);
        this._onChanged = this._onChanged.bind(this);
    }

    _onChanged(event) {
        this.props.onChange(event, this.props.value);
    }

    render() {
        return (
            <label className="radioOption">
                <input type="radio" value={this.props.value} checked={this.props.checked} onChange={this._onChanged} />
                <div className="check" />
                {this.props.children}
            </label>
        );
    }
}

export default RadioOption;


// WEBPACK FOOTER //
// ./src/RadioOption.js